// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3o4EA","dragIcon":"Choice_dragIcon__hOpEY","left":"Choice_left__ID1M6","input":"Choice_input__Lx2x0"};